(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-bomben.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-bomben.js');
"use strict";


async function queryBombenPixAsync(_ref) {
  let {
    drawNumber,
    systemCost
  } = _ref;
  const path = "/wager/1/bomben/pix?flavour=SafeBombenMatchen&size=".concat(systemCost, "&drawNumber=").concat(drawNumber);

  const {
    response
  } = await svs.core.jupiter.callAsync({
    method: 'POST',
    path
  });
  if (response.error || !response.pixes && !response.pix) {
    var _response$error;
    throw new Error(((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message) || 'Failed to query wager-API');
  }
  return response.pixes || [response.pix];
}

const _convertBombenBoardToWager = board => {
  const newBoard = [];
  board.forEach(_ref2 => {
    let {
      outcomes
    } = _ref2;
    const newOutcomes = [];
    outcomes.forEach(outcome => {
      newOutcomes.push([outcome.home.toString(), outcome.away.toString()]);
    });
    newBoard.push(newOutcomes);
  });
  return newBoard;
};
const _getOutcomeType = outcome => {
  const isHomeWin = outcome.home > outcome.away;
  const isDraw = outcome.home === outcome.away;
  const isAwayWin = outcome.home < outcome.away;
  return {
    isHomeWin,
    isDraw,
    isAwayWin
  };
};

const _convertBombenBoardToOutputData = board => {
  const newBoard = [];
  board.forEach(_ref3 => {
    let {
      outcomes
    } = _ref3;
    const newOutcomes = {
      homeWin: [],
      draw: [],
      awayWin: []
    };
    outcomes.forEach(outcome => {
      const outcomeType = _getOutcomeType(outcome);
      if (outcomeType.isHomeWin) {
        newOutcomes.homeWin.push([outcome.home.toString(), outcome.away.toString()]);
      }
      if (outcomeType.isDraw) {
        newOutcomes.draw.push([outcome.home.toString(), outcome.away.toString()]);
      }
      if (outcomeType.isAwayWin) {
        newOutcomes.awayWin.push([outcome.home.toString(), outcome.away.toString()]);
      }
    });
    newBoard.push(newOutcomes);
  });
  return newBoard;
};

function normaliseBombenPix(_ref4) {
  let {
    data = [],
    drawNumber,
    systemCost,
    productId,
    systemType
  } = _ref4;
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error('Missing "pix.events" in response from wager-API.');
  }
  return {
    productId,
    drawNumber,
    systemCost,
    systemType,
    signsByEventForOutput: {
      bomben: _convertBombenBoardToOutputData(data[0].events)
    },
    wagerBoardData: {
      bomben: _convertBombenBoardToWager(data[0].events)
    }
  };
}

setGlobal('svs.components.sport.quickplayModal.hooks', {
  queryBombenPixAsync,
  normaliseBombenPix
});

 })(window);